// extracted by mini-css-extract-plugin
module.exports = {"whitebox":"white-box_whitebox__JrpIK"};